// Meta Pixel — ID: 1206028461436742

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  /* --- Exact Meta Pixel base code --- */
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  f.fbq = n

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  /* --- noscript fallback --- */
  const noscript = b.createElement('noscript')
  const img = b.createElement('img')
  img.height = 1 as any
  img.width = 1 as any
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1206028461436742&ev=PageView&noscript=1'
  noscript.appendChild(img)
  b.body.appendChild(noscript)

  /* --- Init + PageView --- */
  window.fbq('init', '1206028461436742')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'La Botica de la Abuela Moderna',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
